module.exports = __webpack_public_path__ + "static/media/front-runner-thumbnail.ba7b8e78.jpg";